<template>
    <div class="store" :data-id="store.ID">
        <div class="store-list-logo">
            <span v-if="isKingdom">
                <img :src="markerUrl" alt="Reynolds Kingdom of Golf">
            </span>

            <span v-if="isLevel && !isKingdom">
                {{ levelNumber }}<br>
                <img :src="markerUrl" :alt="levelNumber + ' Fitting'">
            </span>

            <span v-if="!isLevel && !store._isFittingEvent && !isKingdom">
                <img :src="markerUrl" alt="Retailer"><br>
            </span>

            <span v-if="store._isFittingEvent && !isKingdom">
                <img :src="markerFeUrl" alt="Fitting Event">
            </span>

            <span v-if="isNfc" class="nfc-tooltip">
                <img :src="markerNfcUrl" alt="National Fitting Council">
                <div class="nfc-desc">The National Fitters Council are the best club fitting professionals in their region. Through the use of technology and a dedication to the art of club fitting, these members are highly influential equipment experts</div>
            </span>

            <span v-if="isAmbassador" class="nfc-tooltip">
                <img :src="markerAmbassadorUrl" alt="TaylorMade Ambassador">
                <div class="nfc-desc">TaylorMade Ambassadors are an elite group of 50 European professionals that are influential members of the golf industry and TaylorMade equipment experts.</div>
            </span>
        </div>

        <div class="store-list-details">
            <div class="location-name">
                {{ store.name }}
            </div>

            <div class="location-distance">
                {{ distance }}<br>
            </div>

            <div class="location-address">
                {{ store.address1 }}<br>
                {{ store.city }}, {{ store.stateCode }} {{ store.postalCode }}
            </div>

            <div v-if="phone" class="location-phone">
                {{ phone }}
            </div>

            <div if="store._locationType" class="location-type">
                {{ store._locationType }}
            </div>

            <div v-if="store._isFittingEvent && store.storeEvents" class="book-now">
                <strong>Events:</strong>
                <div v-html="store.storeEvents" />
            </div>

            <div v-if="store.customEvents" class="book-now generic">
                <a :href="store.customEvents.url" target="_blank">Find a Fitting</a>
            </div>

            <div v-if="isGolfGalaxy && !store.customEvents" class="book-now generic">
                <a href="https://www.golfgalaxy.com/s/golf-services" target="_blank">Find a Fitting</a>
            </div>
        </div>
    </div>
</template>

<script>
import LOGIC from '../utils/logic';
import Icons from '../utils/icons';

export default {
    props: ['store'],

    computed: {
        isGolfGalaxy () {
            return this.store.name.toUpperCase().indexOf('GOLF GALAXY') >= 0;
        },

        phone () {
            return LOGIC.phone(this.store);
        },

        distance () {
            return LOGIC.distance(this.store);
        },

        isLevel () {
            return LOGIC.isLevel(this.store);
        },

        isKingdom () {
            return this.store._isKingdom;
        },

        markerFeUrl () {
            return Icons.getPath('FITTING', 'label');
        },

        markerNfcUrl () {
            return Icons.getPath('NFC', 'label');
        },

        markerAmbassadorUrl () {
            return Icons.getPath('AMBASSADOR', 'label');
        },

        isNfc () {
            return this.store._isNFC;
        },

        isAmbassador () {
            return this.store._isAmbassador;
        },

        levelNumber () {
            if (this.state.appRegion === 'us') {
                if (this.store._isPremier) return 'PREMIER';
                if (this.store._isKingdom) return 'PREMIER';
                if (this.store._isCore) return 'CORE';
                if (this.store._isCertified) return 'CERTIFIED';

                return 'RETAILER';
            }

            return '';
        },

        markerUrl () {
            if (this.state.appRegion === 'us') {
                if (this.store._isKingdom) return Icons.getPath('REYNOLDS', 'label');
                if (this.store._isPremier) return Icons.getPath('PREM', 'label');
                if (this.store._isCertified) return Icons.getPath('CERT', 'label');
                if (this.store._isCore) return Icons.getPath('CORE', 'label');
            }

            if (this.state.appRegion === 'eu') {
                if (this.store._isPerformanceLab) return Icons.getPath('TMPL', 'label');
                if (this.store._isPerformanceStudio) return Icons.getPath('TMPS', 'label');
                if (this.store._isPerformanceCenter) return Icons.getPath('TMPC', 'label');
                if (this.store._isSelectFit) return Icons.getPath('SELECT', 'label');
            }

            return Icons.getPath('RETAIL', 'label');
        }
    }
};
</script>

<style>
.store {
    font-size: 13px;
    color: #333;
    display: flex;
}

.store-list-logo {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.store-list-logo span {
    font-size: 10px;
    color: #595959;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 1px;
}
.store-list-logo img {
    margin-top: 5px;
    max-width: 40px;
    padding-bottom: 10px;
}

.nfc-tooltip {
    position: relative
}

.nfc-desc {
    color: #595959;
    display: none;
    position: absolute;
    background: #fff;
    padding: 12px;
    width: 300px;
    box-shadow: 0 5px 10px rgba(0,0,0,0.4);
    font-size: 12px;
    top: 10px;
    left: 10px;
    z-index: 100;
}
.nfc-tooltip:hover .nfc-desc {
    display: block
}

.store-list-details {
    width: 75%;
    padding: 0px 10px 0;
}
.location-name {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 4px;
}
.location-address {
    font-size: 12px;
    margin-bottom: 4px;
}
.location-distance {
    font-size: 12px;
    color: #595959;
    margin-bottom: 8px;
}
.location-phone {
    font-size: 12px;
    margin-bottom: 8px;
}
.location-type {
    font-weight: bold;
    font-size: 12px;
}
.book-now {
    margin-bottom: 5px;
}
.book-now.generic {
    margin-top: 10px;
}
/* .book-now a { */
    /* background: #333;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: bold;
    display: block;
    text-align: center;
    padding: 10px;
    border-radius: 1px;
    margin-top: 3px;
 }
.book-now a:hover {
    background: #666;
} */
</style>
